import { render, staticRenderFns } from "./InstitutionSettingsAttendence.vue?vue&type=template&id=9b98c5e0"
import script from "./InstitutionSettingsAttendence.vue?vue&type=script&lang=js"
export * from "./InstitutionSettingsAttendence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports